
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirea579"];
var parcelRegister = parcelRequire.register;
parcelRegister("lxZ1n", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $fafc03961bd78d23$var$_jquery = $fafc03961bd78d23$var$_interopRequireDefault((parcelRequire("jG4hL")));
function $fafc03961bd78d23$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
// ====================================================================================
// copyIban.module
// ====================================================================================
var $fafc03961bd78d23$var$init = module.exports.init = function init() {
    (0, $fafc03961bd78d23$var$_jquery["default"])("[data-func='copy-iban']").on("click", function(e) {
        // let $parent = $(e.target).parent();
        // let $feedback = $parent.find(".iban-feedback");
        var $temp = (0, $fafc03961bd78d23$var$_jquery["default"])("<input>");
        (0, $fafc03961bd78d23$var$_jquery["default"])("body").append($temp);
        $temp.val((0, $fafc03961bd78d23$var$_jquery["default"])("#donation-iban").text()).select();
        document.execCommand("copy");
        $temp.remove();
        (0, $fafc03961bd78d23$var$_jquery["default"])(e.target).text("IBAN kopiert").addClass("bg-clr-3");
        setTimeout(function() {
            return (0, $fafc03961bd78d23$var$_jquery["default"])(e.target).text("IBAN kopieren").removeClass("bg-clr-3");
        }, 3000);
    // $feedback.slideDown(400, () => {
    //   setTimeout(() => $feedback.slideUp(400), 5000);
    // });
    });
};

});


//# sourceMappingURL=copyIban.module.9147e781.js.map
